export class AddSubFolderVM {
    folderID: number;
    userID: string;
    databaseID: number;
    organizationId:number;
    OfficeIDList: any[];
    officeID:number=0
}
